"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  DRAFT: 'DRAFT',
  PENDING_MASTER: 'SUBMITTED',
  EDITING: 'EDITING IN PROGRESS',
  INTERNAL_REVIEW: 'INTERNAL REVIEW',
  PENDING_REVIEW: 'PENDING REVIEW',
  APPROVED: 'APPROVED',
  PENDING_SOCIAL_REVIEW: 'PENDING SOCIAL REVIEW',
  COST_REVIEW: 'COST REVIEW',
  ON_HOLD: 'ON HOLD'
};
exports.default = _default;